'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["json"] = "application/json";
  ContentType2["formData"] = "multipart/form-data";
  ContentType2["urlEncoded"] = "application/x-www-form-urlencoded";
  return ContentType2;
})(ContentType || {});

exports.ContentType = ContentType;
